import IntlMessages from "../../layout/components/lang/IntlMessages";

const apps = [
  {
    header: <IntlMessages id="sidebar-apps" />,
  },
  {
    id: "users",
    title: "Usuários",
    icon: <i className="ph-bold ph-users" />,
    navLink: "/apps/users",
    adminOnly: true,
  },
  // {
  //   id: "contact",
  //   title: <IntlMessages id="sidebar-apps-contact" />,
  //   icon: <i className="ph-fill ph-address-book" />,
  //   navLink: "/apps/contact",
  // },
  {
    id: "branch", // Filiais
    title: <IntlMessages id="sidebar-apps-branch" />,
    icon: <i className="ph-bold ph-factory" />,
    navLink: "/apps/branch",
  },
  {
    id: "supplier", // Fornecedores
    title: <IntlMessages id="sidebar-apps-suppliers" />,
    icon: <i className="ph-bold ph-address-book" />,
    navLink: "/apps/supplier",
  },
  {
    id: "nfe",
    title: <IntlMessages id="sidebar-apps-nfes" />,
    icon: <i className="ph-bold ph-handbag" />,
    children: [
      {
        id: "nfe-summary", // Resumo Notas fiscais
        title: <IntlMessages id="nfe-summary-title" />,
        icon: <i className="ph-bold ph-file-xls" />,
        navLink: "/main/dashboard/nfes/summary",
      },
      {
        id: "nfe-list", // Notas fiscais
        title: <IntlMessages id="nfe-title" />,
        icon: <i className="ph-bold ph-file-xls" />,
        navLink: "/main/dashboard/nfes",
      },
      {
        id: "nfe-import", // Notas fiscais importar
        title: <IntlMessages id="nfe-import" />,
        icon: <i className="ph-bold ph-file-xls" />,
        navLink: "/main/dashboard/nfes/import",
      },
    ],
  },
  {
    id: "product",
    title: <IntlMessages id="sidebar-apps-product" />,
    icon: <i className="ph-bold ph-handbag" />,
    children: [
      {
        id: "products",
        title: <IntlMessages id="sidebar-apps-my-purchases" />,
        navLink: "/apps/product",
      },
      {
        id: "products-filter",
        title: <IntlMessages id="sidebar-apps-my-purchases-filter" />,
        navLink: "/apps/product-filter",
      },
    ],
  },
];

export default apps;
